import { FiltersFormHistorian } from 'shell/view-models/search-historian';
import { FiltersHistorianSearch } from './filters-historian-search';

export const initialValues: FiltersFormHistorian = {
  isChildComponentVisited: false,
  page: 0,
  rowsPerPage: 10,
  orders: {},
  subjectData: {
    fiscalCode: '',
    name: '',
    surname: '',
    nameOperation: '0',
    surnameOperation: '0',
    birthday: null,
    birthChoice: ['day', 'month', 'year'],
  },
  openedAccordion: FiltersHistorianSearch.FiscalCode,
  isPersonsListVisited: false,
  matricola: '',
  cardNumber: '',
  searchByFiscalCode: {
    fiscalCode: '',
  },
};
